import React, { useState, useEffect } from "react";
import TeamSection from "./TeamSection";
import TeamHero from "./TeamHero";
import TeamStructure from "./TeamStructure";

export default function Team() {
  return <div>
    <TeamHero />
    <TeamSection />
    <TeamStructure />
  </div>;
}
